import { useState } from 'react';
import { Badge, Button } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { FloatChatWindow } from './float-chat-window';

export function FloatChatBot() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setUnreadCount(0);
      setIsMinimized(false);
    }
  };

  return (
    <>
      {/* Floating Button */}
      {!isOpen && (
        <Badge count={unreadCount} offset={[-5, 5]}>
          <FloatingButton
            shape="circle"
            size="large"
            icon={<MessageOutlined style={{ fontSize: '24px' }} />}
            onClick={handleToggle}
          />
        </Badge>
      )}

      {/* Chat Window */}
      {isOpen && (
        <FloatChatWindow
          isOpen={isOpen}
          isMinimized={isMinimized}
          setIsMinimized={setIsMinimized}
          setUnreadCount={setUnreadCount}
          handleToggle={handleToggle}
        />
      )}
    </>
  );
}

const FloatingButton = styled(Button)`
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 60px;
  height: 60px;
  box-shadow: 0 4px 12px rgba(178, 38, 48, 0.15);
  background-color: #ae2630 !important;
  border-color: #ff5360 !important;
  z-index: 1000;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }
`;
